var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisplayad({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DisplayAd",
    transform: "translate(-1301 -344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8218",
    "data-name": "Rectangle 8218",
    transform: "translate(1301 344)",
    fill: "#e8eaed",
    stroke: "#dee1e5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 46,
    height: 46,
    rx: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "image",
    transform: "translate(1313.069 358.553)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30481",
    "data-name": "Path 30481",
    d: "M5.953,158.441a3.566,3.566,0,0,1-3.374-2.43l-.033-.11a3.477,3.477,0,0,1-.165-1.033v-6.494L.07,156.088a2.163,2.163,0,0,0,1.516,2.624l14.729,3.944a2.184,2.184,0,0,0,.549.07,2.124,2.124,0,0,0,2.058-1.557l.858-2.729Zm0,0",
    transform: "translate(0 -141.28)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30482",
    "data-name": "Path 30482",
    d: "M151.225,68.3A1.905,1.905,0,1,0,149.32,66.4,1.907,1.907,0,0,0,151.225,68.3Zm0,0",
    transform: "translate(-142.653 -61.142)",
    fill: "#1b1c1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30483",
    "data-name": "Path 30483",
    d: "M101.989.492H87.7A2.385,2.385,0,0,0,85.32,2.874V13.351A2.385,2.385,0,0,0,87.7,15.732h14.288a2.385,2.385,0,0,0,2.381-2.381V2.874A2.385,2.385,0,0,0,101.989.492ZM87.7,2.4h14.288a.476.476,0,0,1,.476.476V9.635L99.457,6.124a1.706,1.706,0,0,0-1.277-.586,1.665,1.665,0,0,0-1.272.6l-3.538,4.246-1.152-1.15a1.672,1.672,0,0,0-2.362,0l-2.629,2.628V2.874A.476.476,0,0,1,87.7,2.4Zm0,0",
    transform: "translate(-81.511)",
    fill: "#1b1c1d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisplayad);
export default __webpack_public_path__ + "static/media/displayad.d7fd7bf10f1fad431f3f035e70b4461b.svg";
export { ForwardRef as ReactComponent };